export default __webpack_public_path__ + "static/media/emp-directories.46043fa7.jpg";